import { ESort } from '../../repositories/newbuilding-reviews/entities/get_reviews_web/GetReviewsWebRequestSchema';
import { ESortType } from '../../types/sort';

const mapper = {
  [ESortType.By_date_asc]: ESort.By_date_asc,
  [ESortType.By_date_desc]: ESort.By_date_desc,
  [ESortType.By_rating_asc]: ESort.By_rating_asc,
  [ESortType.By_rating_desc]: ESort.By_rating_desc,
  [ESortType.Default]: ESort.Default,
};

export const prepareSortRequest = (sort?: ESortType | null): ESort | null => {
  return sort ? mapper[sort] : null;
};
